import React from 'react';
import _ from 'lodash';

import {TableListRow, TableListCell} from './../TableList';
import component, {classnames, navigateTo, makePath} from './../component';
import Flag from './../Flag';
import LoadMoreButton from './../LoadMoreButton';
import Link from '../Link';


import {CancelSmall, CheckedSmall} from './../icons';

import {getRandomInt, randomString} from './../randomizer.js';

import TournamentDetails from './TournamentDetails';

const TeamStatus = {
  1: function() {
      return (
        <div className="TableListCell-ItemState">
          <div className="TableListCell-ItemStateStatus">
            <CancelSmall className='TeamList-IconCancel' />
          </div>
          <div>Еще не подтвердили участие</div>
        </div>
      )
    },
  2: function() {
      return (
        <div className="TableListCell-ItemState">
          <div className="TableListCell-ItemStateStatus">
            <CheckedSmall className='TeamList-IconChecked' />
          </div>
          <div>Подтвердили участие</div>
        </div>
      )
    },
  null: function(){
    return (
      <div className="TableListCell-ItemState">
        <div className="TableListCell-ItemStateStatus">
          <CheckedSmall className='TeamList-IconChecked' />
        </div>
        <div>Дополнительный участник</div>
      </div>
    )
  }

};

const TeamsList = component('TeamsList', function({list}) {
  return (
    <div className="TournamentTeamsList">
      {list.map((team, index) => {
        const itemImage = team.get('image');
        const bgImage = itemImage
            ? itemImage + '?crop=1&w=88&h=88'
            : require('../../img/teamEmptyAvatarSquare.png');
        return <TableListRow key={index} height={88} bordered={true}>
          <TableListCell width={88} type='Logo'>
            <Link name='teamDetails' className="TableListCell-Avatar"  params={{id: team.get('id')}} style={{
              backgroundImage: `url(${bgImage})`,
              width: 88,
              height: 88
            }} />
          </TableListCell>
          <TableListCell width={272} type='Primary'>

            <div className='TeamList-TeamInfo'>
              <div className='TeamList-TeamTitleCountry'>
                <Link name='teamDetails' params={{id: team.get('id')}} className='TeamList-TeamTitle'>
                  {team.get('title')}
                </Link>
                <div className='TeamList-TeamCountry'>
                  <Flag country={team.get('country')} outputName={true}/>
                </div>
              </div>
            </div>
          </TableListCell>
          <TableListCell width={112} type='Secondary' header='Матчей'>{team.get('total_games')}</TableListCell>
          <TableListCell width={112} type='Secondary' header='Побед'>{team.get('won_games')}</TableListCell>
          <TableListCell width={120} type='Secondary' header='Поражений'>{team.get('lost_games')}</TableListCell>
          <TableListCell width={112} type='Secondary' header='Очки'>{team.get('score')}</TableListCell>
          <TableListCell width={368} type='Action'>
            {TeamStatus[team.get('application_status')]()}
          </TableListCell>

        </TableListRow>
      })}
      {/*<LoadMoreButton text='команд'/>*/}
    </div>
    )
});

export default component('TournamentTeamsList', function({data, params}) {

  const teamsList = data.getIn(['tournamentData', +params.id, 'teams']);
  if (teamsList) {
    teamsList.set(_.sortBy(teamsList.toJS(), 'applied_at'));
  }

  return (
    <TournamentDetails content={<TeamsList list={teamsList} />} data={data} params={params}/>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/TournamentTeamsList.js